var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.94 385.93v25.49a27.92 27.92 0 0 0 27.92 27.92h368.28a27.92 27.92 0 0 0 27.92-27.92v-25.49z",
    fill: "#5f6a78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m200.6 439.34h110.8v66.02h-110.8z",
    fill: "#475673"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m440.14 142.64h-368.28a27.92 27.92 0 0 0 -27.92 27.92v215.37h424.12v-215.37a27.92 27.92 0 0 0 -27.92-27.92zm-19.14 124.72a.5.5 0 0 1 -.5-.5.5.5 0 0 1 1 0 .5.5 0 0 1 -.5.5z",
    fill: "#e5f5fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m187.41 335.22a13.906 13.906 0 0 1 27.81.18v3.21a17.11 17.11 0 1 0 34.22 0v-94.21h28.24v94.21a17.11 17.11 0 1 0 34.22 0v-11.34a14.334 14.334 0 0 1 28.46-2.42 21.374 21.374 0 0 1 36.99 14.61l.55 1.26a30.008 30.008 0 0 1 38.34 45.21h-322.76a30.01 30.01 0 0 1 45.86-38.16l.16-.18a25.514 25.514 0 0 1 47.91-12.37zm161.59 26.14a1 1 0 1 0 -1 1 1 1 0 0 0 1-1zm-180-10a1 1 0 1 0 -1 1 1 1 0 0 0 1-1z",
    fill: "#ed6337"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m353.39 261.51h20.54v18.06h-20.54z",
    fill: "#50a6ea"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m306.34 244.4v14.64 2.47h67.59v-2.47-14.64z",
    fill: "#a6b7d0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m361.53 190.92a42.241 42.241 0 0 0 -29.95-12.4 25.24 25.24 0 0 1 -25.24-25.24v91.12h67.59v-23.53a42.258 42.258 0 0 0 -12.4-29.95z",
    fill: "#50a6ea"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m306.34 261.51h20.53v18.06h-20.53z",
    fill: "#50a6ea"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m306.34 235.94v8.46h-28.66v-28.73-.09h28.66z",
    fill: "#7f8a98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m302.38 61.09c-2.62-9.77-6.55-19.33-11.75-34.94a28.535 28.535 0 0 0 -54.14 0c-10.41 31.22-15.71 38.24-15.71 71.14v118.29h85.56v-118.29c0-16.45-1.33-26.43-3.96-36.2z",
    fill: "#a0eaea"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m277.68 215.67v28.73h-28.24v-28.73-.09h28.24z",
    fill: "#a6b7d0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m249.44 215.67v28.73h-28.66v-8.46-20.36h28.66z",
    fill: "#7f8a98"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m200.25 261.51h20.53v18.06h-20.53z",
    fill: "#50a6ea"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m153.19 244.4v14.64 2.47h67.59v-2.47-14.64z",
    fill: "#a6b7d0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m195.54 178.52a42.336 42.336 0 0 0 -42.35 42.35v23.53h67.59v-91.12a25.24 25.24 0 0 1 -25.24 25.24z",
    fill: "#50a6ea"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m153.19 261.51h20.53v18.06h-20.53z",
    fill: "#50a6ea"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m73.94 411.42v-25.49h-30v25.49a27.92 27.92 0 0 0 27.92 27.92h30a27.92 27.92 0 0 1 -27.92-27.92z",
    fill: "#475673"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m101.86 142.64h-30a27.92 27.92 0 0 0 -27.92 27.92v215.37h30v-215.37a27.92 27.92 0 0 1 27.92-27.92z",
    fill: "#a6b7d0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m266.49 26.15a27.906 27.906 0 0 1 12.07-15.363 29 29 0 0 0 -15-4.147 28.012 28.012 0 0 0 -27.07 19.51c-10.41 31.22-15.71 38.24-15.71 71.14v118.29h30v-118.29c0-32.9 5.3-39.92 15.71-71.14z",
    fill: "#81ccca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#284268"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440.143 137h-128.143v-39.707c0-27.552-3.588-38.133-10.407-57.342-1.613-4.543-3.357-9.692-5.358-15.694a34.489 34.489 0 0 0 -65.459 0c-2 6-3.708 11.151-5.32 15.694-6.82 19.209-10.456 29.79-10.456 57.342v39.707h-143.143a33.6 33.6 0 0 0 -33.857 33.557v240.865a33.616 33.616 0 0 0 33.857 33.578h123.143v54h-24.8a6 6 0 0 0 0 12h176.624a6 6 0 1 0 0-12h-29.824v-54h123.143a33.616 33.616 0 0 0 33.857-33.578v-240.865a33.6 33.6 0 0 0 -33.857-33.557zm-128.143 98.938v-58.074c6 4.163 12.191 6.655 19.444 6.655a36.568 36.568 0 0 1 36.556 36.351v17.13h-56zm0 14.062h56v6h-56zm56 18v6h-9v-6zm-56 0h9v6h-9zm-85-114.721v-55.986c0-25.485 2.988-34.21 9.775-53.327 1.631-4.594 3.424-9.8 5.461-15.914 3.787-11.36 13.5-15.408 21.35-15.408s17.577 4.048 21.364 15.408c2.037 6.112 3.71 11.32 5.341 15.914 6.787 19.117 9.709 27.842 9.709 53.327v112.707h-73zm73 68.721v16h-16v-16zm34.578 123.463a6 6 0 0 0 6-6 15.385 15.385 0 0 1 30.7-1.417 36.125 36.125 0 0 0 -5.168 4.947 6 6 0 1 0 9.126 7.791 24.013 24.013 0 0 1 38.035 29.216h-316.308a23.2 23.2 0 0 1 -2.463-10.612 24.006 24.006 0 0 1 44.456-12.588 6 6 0 0 0 10.219-6.3 36.6 36.6 0 0 0 -3.578-4.84 19.777 19.777 0 0 1 19.188-17.738 19.212 19.212 0 0 1 13.878 5.624 20.619 20.619 0 0 1 6.171 14.618 22.212 22.212 0 0 0 22.187 22.186 6 6 0 0 0 0-12 10.2 10.2 0 0 1 -10.187-10.187 32.461 32.461 0 0 0 -3.291-14.163 7.781 7.781 0 0 1 15.457 1.4v3.209a23 23 0 1 0 46 0v-88.609h17v88.608a23 23 0 1 0 46 0v-11.337a8.277 8.277 0 0 1 15.7-3.706 27.235 27.235 0 0 0 -5.121 15.9 6 6 0 0 0 5.999 5.998zm-79.578-107.463v-16h17v16zm-28-2.062v-13.938h16v16h-16zm-177-65.381a21.587 21.587 0 0 1 21.857-21.557h143.143v4.279a19.438 19.438 0 0 1 -19.445 19.24 48.581 48.581 0 0 0 -48.555 48.351v58.7a6.542 6.542 0 0 0 6.189 6.43h20.534a6.619 6.619 0 0 0 6.277-6.427v-11.573h14v11.573a6.592 6.592 0 0 0 6.246 6.427h20.534a6.569 6.569 0 0 0 6.22-6.427v-29.573h16v88.608a11 11 0 1 1 -22 0v-3.208a19.769 19.769 0 0 0 -35.642-11.917 31.039 31.039 0 0 0 -20.828-7.552 31.837 31.837 0 0 0 -29.346 21.516 36.017 36.017 0 0 0 -52.684 31.941 34.308 34.308 0 0 0 1.587 10.612h-34.087zm109 85.443v-6h56v6zm56 12v6h-9v-6zm-47 0v6h-9v-6zm-9-30v-17.13a36.567 36.567 0 0 1 36.555-36.351c7.254 0 13.445-2.492 19.445-6.655v60.136zm146 261h-98v-54h98zm157-87.578a21.6 21.6 0 0 1 -21.857 21.578h-368.286a21.6 21.6 0 0 1 -21.857-21.578v-19.422h412zm0-31.422h-35.167a35.115 35.115 0 0 0 2.667-13.612 36.009 36.009 0 0 0 -47.154-34.248 27.371 27.371 0 0 0 -39.589-16.662 20.242 20.242 0 0 0 -36.757 11.793v11.337a11 11 0 1 1 -22 0v-88.608h16v29.573a6.674 6.674 0 0 0 6.337 6.427h20.534a6.489 6.489 0 0 0 6.129-6.427v-11.573h14v11.573a6.725 6.725 0 0 0 6.394 6.427h20.534c3.313 0 6.072-3.113 6.072-6.427v-58.7a48.581 48.581 0 0 0 -48.556-48.351 19.438 19.438 0 0 1 -19.444-19.243v-4.279h128.143a21.587 21.587 0 0 1 21.857 21.557z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401,
    cy: 296.856,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 285.356a6 6 0 0 0 6-6v-41a6 6 0 0 0 -12 0v41a6 6 0 0 0 6 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421,
    cy: 266.856,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420 189.124a6 6 0 0 0 6-6v-10.768a6 6 0 0 0 -12 0v10.768a6 6 0 0 0 6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420 255.356a6 6 0 0 0 6-6v-43.78a6 6 0 0 0 -12 0v43.78a6 6 0 0 0 6 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 300.856,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105 289.356a6 6 0 0 0 6-6v-41a6 6 0 0 0 -12 0v41a6 6 0 0 0 6 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 270.856,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125 193.124a6 6 0 0 0 6-6v-10.768a6 6 0 0 0 -12 0v10.768a6 6 0 0 0 6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125 259.356a6 6 0 0 0 6-6v-43.78a6 6 0 0 0 -12 0v43.78a6 6 0 0 0 6 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 361.356,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 311.356,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 351.356,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.559 51.979a34.061 34.061 0 0 0 -32.759 23.613 6 6 0 0 0 11.384 3.8c3.787-11.361 13.526-15.408 21.378-15.408s17.59 4.047 21.377 15.408a6 6 0 0 0 11.384-3.8 34.06 34.06 0 0 0 -32.764-23.613z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.99d5c8289f60d1433e08928c5b4969ce.svg";
export { ForwardRef as ReactComponent };